// extracted by mini-css-extract-plugin
module.exports = {"Badge":"badge_Badge__1iFk2"};